/*
 * ContentTemplate — escolhe a composicao da pagina de conteudo pela `variation`.
 *
 * O template conhece os SLOTS do grid, nao a lista de blocos: cada pagina se le em JSX, de cima
 * para baixo, e cada bloco recebe props e dado sem depender do pai. Vem do `PhoneTemplate` do
 * Next, que servia as quatro paginas de conteudo com `ArticlesTemplate` e
 * `InterpretationTemplate` como irmaos.
 *
 * `head` e `children` sao `DocumentFragment` e nao `ReactNode` de proposito: sao os nos que o
 * PHP ja pintou, adotados por `AdoptedRegion` sem reserializar. O mesmo vale para as regioes de
 * `adopted`.
 */
import React from 'react';

import { IContentTemplateProps } from './types';

import ArticleTemplate from './ArticleTemplate';
import InterpretationTemplate from './InterpretationTemplate';

const ContentTemplate: React.FC<IContentTemplateProps> = ({ variation, data, head, body, adopted }) => (
    variation === 'article'
        ? <ArticleTemplate data={data} head={head} body={body} />
        : (
            <InterpretationTemplate
                data={data}
                head={head}
                body={body}
                adopted={adopted}
                variation={variation}
            />
        )
);

export default ContentTemplate;
